var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ask.comments
    ? _c(
        "div",
        { staticClass: "mt-10" },
        [
          _c(
            "md-card",
            { attrs: { id: "commentDivSection" } },
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    {
                      ref: "commentDivSection",
                      attrs: { "md-alignment": "space-between" }
                    },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "expand-button-size" },
                            [
                              _c("strong", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "upper-word",
                                    on: {
                                      click: function($event) {
                                        return _vm.expandChild("comment")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("Comments "),
                                    _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.ask.comments.length) +
                                          ")"
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      this.$parent.opened.includes("comment")
                        ? _c("md-card-content", { staticClass: "comments" }, [
                            _c(
                              "div",
                              { staticClass: "comments" },
                              _vm._l(_vm.sortComments, function(
                                comment,
                                index
                              ) {
                                return _vm.ask.comments &&
                                  _vm.ask.comments.length
                                  ? _c(
                                      "div",
                                      {
                                        key: "comment-" + index,
                                        staticClass: "activity"
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("momentDate")(comment.when)
                                            ) +
                                              " - " +
                                              _vm._s(comment.memberName)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "ask-description" },
                                          [_vm._v(_vm._s(comment.comment))]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.submitComment.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "create-ask textareaAfter" },
                                    [
                                      _c("md-textarea", {
                                        staticClass:
                                          "md-textarea padding-left-10",
                                        attrs: {
                                          placeholder: "Enter your comment"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.commentText = _vm.sanitizeInput(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.commentText,
                                          callback: function($$v) {
                                            _vm.commentText = $$v
                                          },
                                          expression: "commentText"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "create-ask" },
                                    [
                                      _c(
                                        "md-button",
                                        {
                                          staticClass:
                                            "md-accent md-raised upper-word md-white-color",
                                          attrs: { type: "submit" }
                                        },
                                        [_vm._v("Add Comment")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5847e424", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5847e424","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comments.vue
// module id = null
// module chunks = 